import moment from 'moment'

/**
 * Set of helper functions
 * */
const helper = {
  DIRECTION_ASC: 'asc',
  DIRECTION_DESC: 'desc',
  /**
   * non-mutating sorting function by one param
   * @param valuePreFormatter - function for converting value before comparing values
   * @returns sorted copy of array
   */
  sortByParam: function (targetArray, propertyName, direction, valuePreFormatter) {
    !direction && (direction = this.DIRECTION_ASC)
    if (direction !== this.DIRECTION_ASC && direction !== this.DIRECTION_DESC) {
      throw new Error('Wrong sorting direction')
    }
    !valuePreFormatter && (valuePreFormatter = (v) => v)
    if (typeof valuePreFormatter !== 'function') {
      throw new Error('Unacceptable valuePreFormatter')
    }
    const copyArr = [...targetArray]
    copyArr.sort((el1, el2) => {
      const el1Value = valuePreFormatter(el1[propertyName])
      const el2Value = valuePreFormatter(el2[propertyName])

      let comparingResult = el1Value > el2Value ? 1 : el1Value < el2Value ? -1 : 0
      return direction === this.DIRECTION_ASC ? comparingResult : -comparingResult
    })

    return copyArr
  },
  /**
   * non-mutating sorting function by multiply params
   * @param valuePreFormatter - function for converting value before comparing values
   * @returns sorted copy of array
   */
  sortByParamMutation: function (targetArray, propertyName, direction, valuePreFormatter) {
    !direction && (direction = this.DIRECTION_ASC)
    if (direction !== this.DIRECTION_ASC && direction !== this.DIRECTION_DESC) {
      throw new Error('Wrong sorting direction')
    }
    !valuePreFormatter && (valuePreFormatter = (v) => v)
    if (typeof valuePreFormatter !== 'function') {
      throw new Error('Unacceptable valuePreFormatter')
    }
    targetArray.sort((el1, el2) => {
      const el1Value = valuePreFormatter(el1[propertyName])
      const el2Value = valuePreFormatter(el2[propertyName])

      let comparingResult = el1Value > el2Value ? 1 : el1Value < el2Value ? -1 : 0
      return direction === this.DIRECTION_ASC ? comparingResult : -comparingResult
    })
  },
  /**
   * mutating sorting function by multiply params
  * propertyConfig = [
  *   {
  *     propertyName: '/some name/',
  *     sortDirection: 'asc | desc',
  *     valuePreFormatter: function (value) => formattedValue - optional
  *   }
  * ]
  * */
  sortByMultipleParams: function (targetArray, propertiesConfig) {
    const copyArr = [...targetArray]
    propertiesConfig.length && copyArr.sort((el1, el2) => {
      return compareRecursive.call(this, el1, el2, propertiesConfig, 0)
    })

    return copyArr
  },
  getNewSortDirection: function (oldDirection) {
    return oldDirection === this.DIRECTION_ASC
      ? this.DIRECTION_DESC
      : oldDirection === this.DIRECTION_DESC ? null : this.DIRECTION_ASC
  },
  getInitialsFromEmail: function (email) {
    if (!email) {
      return ''
    }
    email = email.toString()
    const regex = /[^\w\s]/gi
    return email.split('@')[0].replace(regex, '').substr(0, 2)
  },
  /**
   *
   * @param item @example: {label: 'Label', '_id: 'k323451wi23eb12j3k4b23k4'}
   * @returns {{label: *, value: *}}
   */
  convertListToOptions (item) {
    return {
      label: item.label,
      value: item._id
    }
  },
  /**
   * non-mutating sort snapshots by date
   * @param input - array of snapshots
   * @returns new array of snapshots
   */
  sortSnapshots (input) {
    if (!input) {
      return []
    }
    let snapshots = [...input]
    snapshots.sort((snapshot1, snapshot2) => {
      const date1 = moment(snapshot1)
      const date2 = moment(snapshot2)
      if (date1.isBefore(date2)) {
        return 1
      }
      if (date1.isAfter(date2)) {
        return -1
      }
      return 0
    })
    return snapshots
  },
  isArraysEquals(array1, array2, property = '_id'){
    if(!array1 && !array2){
      return true
    }
    if(!array1 || !array2){
      return false
    }
    if(array1.length !== array2.length){
      return false
    }
    const intersection = _.intersectionBy(array1, array2, property);
    return intersection.length === array1.length && intersection.length === array2.length
  }
}

/**
 * helper function for sortByMultipleParams
 */
function compareRecursive (el1, el2, propertiesConfig, configIndex) {
  if (configIndex >= propertiesConfig.length) {
    throw new Error('Sort by multiple params failed. Unacceptable index')
  }

  let direction = propertiesConfig[configIndex].sortDirection
  direction = direction || this.DIRECTION_ASC
  if (direction !== this.DIRECTION_ASC && direction !== this.DIRECTION_DESC) {
    throw new Error('Wrong sorting direction')
  }
  const multiplier = direction === this.DIRECTION_ASC ? 1 : -1

  let preFormatter = propertiesConfig[configIndex].valuePreFormatter
  preFormatter = preFormatter ? preFormatter : (x) => x
  if (typeof preFormatter !== 'function') {
    throw new Error('Unacceptable valuePreFormatter')
  }

  const propName = propertiesConfig[configIndex].propertyName
  const value1 = preFormatter(el1[propName])
  const value2 = preFormatter(el2[propName])

  if (propertiesConfig[configIndex].sortByLenght) {
    // sort length === 0 to the end
    if (!value1.length || !value2.length) {
      if (value1.length === value2.length) {
        return 0
      } else if (!value1.length) {
        return 1
      } else {
        return -1
      }
    }

    if (value1.length > value2.length) return 1 * multiplier

    if (value1.length < value2.length) return -1 * multiplier
  } else {
    // sort 0 to the end
    // if (propertiesConfig[configIndex].sortZeroToTheEnd && (value1 === 0 || value2 === 0)) {
    //   if ((value2 !== 0 && typeof value2 !== 'string') || typeof value1 === 'string') {
    //     return 1
    //   } else if (value1 === value2) {
    //     return 0
    //   } else {
    //     return -1
    //   }
    // }
    // sort NR or null to the end
    if (value1 === 'NR' || value2 === 'NR' || value1 === 'ND' || value2 === 'ND' || value1 === null || value2 === null) {
      if (value1 === value2) {
        return 0
      } else if (value1 === null || value1 === 'ND' || (value1 === 'NR' && value2 !== 'ND')) {
        return 1
      } else {
        return -1
      }
    }

    if (value1 > value2) return 1 * multiplier

    if (value1 < value2) return -1 * multiplier
  }

  if (configIndex < propertiesConfig.length - 1) {
    return compareRecursive.call(this, el1, el2, propertiesConfig, configIndex + 1)
  } else {
    return 0
  }
}

export default helper
